"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOverlayRoot = useOverlayRoot;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _configContext = require("../config-context");
/**
 * 获取/创建对话框容器
 */

var root;
function useOverlayRoot() {
  var _useConfig = (0, _configContext.useConfig)(),
    classPrefix = _useConfig.classPrefix;
  var rootId = "".concat(classPrefix, "-overlay-root");
  if ((typeof document === "undefined" ? "undefined" : (0, _typeof2.default)(document)) === 'object') {
    root = root || document.getElementById(rootId);
    if (!root) {
      root = document.createElement('div');
      root.id = rootId;
      document.body.appendChild(root);
    }
  }
  return [root];
}